import React from "react";
import useAuth from "@/hooks/useAuth";

export default function LoginCallbackError() {
  const auth = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-sm w-full bg-white rounded-lg shadow-md p-8 text-center">
        <img src="/img/velaro.svg" alt="Velaro" className="h-8 mx-auto mb-6" />
        <p className="text-gray-700 font-medium mb-2">Login Error</p>
        <p className="text-sm text-gray-500 mb-6">
          An unexpected error occurred while signing in. Please try again.
        </p>
        <button
          onClick={() => {
            sessionStorage.clear();
            auth.retryLogin();
          }}
          className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm font-medium"
        >
          Try Again
        </button>
        <a
          href="/"
          className="block mt-3 text-xs text-gray-400 hover:text-gray-600"
        >
          Return to Velaro Admin
        </a>
      </div>
    </div>
  );
}
